import React, { useState } from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import ProgressBar from '../ProgressBar';
import DataProvider from '../../DataProvider';

const UploadButton = ({
    type = 'camera',
    acceptedFileTypes = "image/png, image/gif, image/jpeg, application/pdf",
    endpoint = '/api/cameras/map',
    bucketName = 'sos-maps',
    fileName,
    record
}) => {
    //this could be a prop
    const dataProvider = DataProvider;
    const [progress, setProgress] = useState(0);

    function handleClick() {
        const inputElement = document.getElementById(`${type}-input`);
        inputElement.click();
    }

    function handleErrors() {
        alert('Error uploading file, try again later');
    }
    
    async function retrieveUploadURL() {
        if (!record) return handleErrors();
        const inputElement = document.getElementById(`${type}-input`);
        if (!inputElement) return handleErrors();
    
        const file = inputElement.files[0];
        if (!file) return handleErrors();
    
        const fileType = file.type;
        inputElement.value = null;
    
        // Extracting the file extension
        const fileExtension = file.name.split('.').pop();
    
        // Appending the file extension to the key
        const key = `${type}s/${record.id}/map.${fileExtension}`;
    
        const response = await fetch(endpoint, {
            method: 'POST', body: JSON.stringify({ key, bucket: bucketName, content_type: type, record_id: record.id }), headers: {
                'content-type': 'application/json',
            },
        });
        const resJson = await response.json();
        const { url, fields } = resJson;
    
        return { url, fields, file, fileType };
    }
    
    async function handleFileUpload() {
        const { url, fields, file, fileType } = await retrieveUploadURL();
        const uploadData = {
            ...fields,
            'Content-Type': fileType,
            file
        };


        const formData = new FormData();

        for (const name in uploadData) {
            formData.append(name, uploadData[name]);
        }

        console.log("uploadData", uploadData)
        const axiosRequest = {
            method: "post",
            url: `${url}`,
            data: formData,
            onUploadProgress: (p) => {
                setProgress(p.loaded / p.total);
            }
        }
        axios.request(axiosRequest).then(async response => {
            if (!response) return;

            setProgress(1);

            if (response.status === 204) {
                alert(`Successfully uploaded ${type} file`);
            } else {
                alert(`Error uploading ${type} file, try again later`);
            }
        }). catch(error => {
            console.error('Upload error:', error);
            alert('Failed to upload. Please try again.');
        });
    }

    function handleInputChange() {
        handleFileUpload();
    }

    return (
        <div>
            <Button
                variant="outlined" color="primary" 
                onClick={handleClick}>
                <div style={{ color: '#03a9f4' }}>
                    {`Upload ${type.charAt(0).toUpperCase() + type.slice(1)} Map`}
                    <input id={`${type}-input`} type="file" accept={acceptedFileTypes} onChange={handleInputChange} style={{ display: 'none' }} />
                </div>
            </Button>
            <ProgressBar progress={progress} />
        </div>
    );
}

export default UploadButton;
